import { cn } from '@/lib/utils';

/**
 * Skeleton — простой placeholder с анимацией pulse.
 * shadcn/ui canonical primitive.
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
